import React, { useEffect, useState } from "react";

const Footer = () => {
    const cookieSecurity = "security_storage";
    const cookieFunctionality = "functionality_storage";
    const cookiePersonalization = "personalization_storage";
    const cookieStorage = "analytics_storage";
    const cookieAds = "ad_storage";

    const expirationTime = 2592000 * 1000; // One month in ms
    const date = new Date(Date.now() + expirationTime).toUTCString();
    const domain = `.${location.hostname.replace(/^www\./i, "")}`;

    const setCookie = (name, value) => {
        document.cookie = `${name}=${value}; SameSite=None; Secure; expires=${date}; path=/; domain=${domain}`;
    };

    const getCookie = (name) => {
        return document.cookie.split("; ").find((row) => row.startsWith(name + "="));
    };

    const reload = () => window.location.reload();

    const [showBanner, setShowBanner] = useState(false);

    // Zjistit, zda už jsou povolené cookies
    useEffect(() => {
        if (
            document.cookie.includes("personalization_storage=granted") ||
            document.cookie.includes("analytics_storage=granted") ||
            document.cookie.includes("ad_storage=granted")
        ) {
            setShowBanner(false);
        } else {
            setShowBanner(true);
        }
    }, []);

    const allowAll = () => {
        const valueGranted = "granted";
        setCookie(cookieSecurity, "granted");
        setCookie(cookieFunctionality, "granted");
        setCookie(cookiePersonalization, valueGranted);
        setCookie(cookieStorage, valueGranted);
        setCookie(cookieAds, valueGranted);
        reload();
    };

    return (
        <div>
            <footer id="footer">
                <div className="container">
                    <div className="copyright">
                        Copyright © 2025
                        <br />
                        <a href="/gdpr">Zpracování osobních údajů</a>
                    </div>
                    <div className="contact-info">
                        <div className="cont-act">
                            <small>Zavolejte nám</small>
                            <a href="tel:+420607867936">+420 607 867 936</a>
                        </div>
                        <div className="cont-act">
                            <small>E-mailový kontakt</small>
                            <a href="mailto:info@rychlydum.cz">info@rychlydum.cz</a>
                        </div>
                        <div className="socials">
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.facebook.com/rychlydum/"
                            >
                                <img
                                    src="./images/fb.svg"
                                    alt="Facebook"
                                    width="45"
                                    height="45"
                                />
                            </a>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.instagram.com/rychlydum/"
                            >
                                <img
                                    src="./images/instagram.svg"
                                    alt="Instagram"
                                    width="45"
                                    height="45"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </footer>

            {showBanner && (
                <section className="cookies cookies-popup" id="cookiesConsent">
                    <header className="cookies_header">
                        <p>
                            Můžeme pracovat s cookies,
                            <br />
                            ať víme, jak to na našem webu žije?
                        </p>
                    </header>

                    <div id="cookiesConsentForm" className="cookies_form">
                        <div className="btn-group cookies_actions">
                            <a href="/cookies" className="bttn-link">
                                Nastavení
                            </a>
                            <button
                                className="bttn allow_all"
                                data-type="allow_all"
                                onClick={allowAll}
                            >
                                Povolit vše
                            </button>
                        </div>
                    </div>

                    <div className="cookies_links">
                        <a href="/cookies">Cookies</a>
                        <a href="/gdpr">Zpracování osobních údajů</a>
                    </div>
                </section>
            )}
        </div>
    );
};

export default Footer;
